import type { ChipComponent } from "@app/widgets/base/chip/chip.component";
import type { CbSelectOption } from "@app/widgets/base/select/select.component";

export const ALERT_ICON_MAP: Record<string, string> = {
	missing_udc: "cb-app-outline-package-search",
	damaged_udc: "cb-app-outline-package-remove",
	skipped_serials: "cb-app-outline-search-visual",
	wrong_position: "cb-app-outline-trolley-01",
	empty_udc_position: "cb-app-outline-border-none-01",
};

export const ALERT_LABEL_MAP: Record<string, string> = {
	missing_udc: "PALLETS.ALERTS.MISSING_UDC",
	damaged_udc: "PALLETS.ALERTS.DAMAGED_UDC",
	skipped_serials: "PALLETS.ALERTS.SKIPPED_SERIALS",
	wrong_position: "PALLETS.ALERTS.WRONG_POSITION",
	empty_udc_position: "PALLETS.ALERTS.EMPTY_UDC_POSITION",
};

export const ALERT_COLOR_MAP: ReturnType<
	typeof ChipComponent.prototype.colorMap
> = {
	missing_udc: "info",
	damaged_udc: "dark-orange",
	skipped_serials: "warning",
	wrong_position: "green",
	empty_udc_position: "rose",
};

export const ALERT_LABEL_OPTIONS: CbSelectOption[] = [
	{
		label: "PALLETS.ALERTS.DAMAGED_UDC",
		value: "damaged_udc",
	},
	{
		label: "PALLETS.ALERTS.MISSING_UDC",
		value: "missing_udc",
	},
	// {
	// 	label: "PALLETS.ALERTS.SKIPPED_SERIALS",
	// 	value: "skipped_serials",
	// },
	{
		label: "PALLETS.ALERTS.WRONG_POSITION",
		value: "wrong_position",
	},
	{
		label: "PALLETS.ALERTS.EMPTY_UDC_POSITION",
		value: "empty_udc_position",
	},
];
